import { render, staticRenderFns } from "./ChannelSwiper.vue?vue&type=template&id=3e3230e0&scoped=true"
import script from "./ChannelSwiper.vue?vue&type=script&lang=js"
export * from "./ChannelSwiper.vue?vue&type=script&lang=js"
import style0 from "./ChannelSwiper.vue?vue&type=style&index=0&id=3e3230e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3230e0",
  null
  
)

export default component.exports